import API from '../functions/api';
import _find from 'lodash/find';

const UPDATE_ALL = "DEALERS/UPDATE_ALL";
const UPDATE_SUBURBS = "DEALERS/UPDATE_SUBURBS";
const UPDATE_DEALERS_BY_SUBURB = "DEALERS/UPDATE_DEALERS_BY_SUBURB";
const UPDATE_CURRENT = "DEALERS/UPDATE_CURRENT";
const UPDATE_SELECTED = "DEALERS/UPDATE_SELECTED";
const SET_IS_FETCHING = "DEALERS/SET_IS_FETCHING";

export function fetchSuburbsByPostcode(postcode, cb, errorCb) {
    return (dispatch, getState) => {
        if (!postcode) { return Promise.resolve(); }
        const {dealers} = getState();
        if (dealers.suburbsByPostcode[postcode] && dealers.suburbsByPostcode[postcode].length > 0) {
            if (typeof cb === "function") {
                cb(dealers.suburbsByPostcode[postcode]);
            }
            return Promise.resolve();
        }
        dispatch({type: SET_IS_FETCHING, payload: {isLoadingSuburbs: true}});
        return API.post(
          process.env.RAZZLE_GQLAPI,
          {
            query: /* GraphQL */`query () {
              suburbsByPostcode(postcode: "${postcode}") {
                value: id
                label: suburb
              }
            }`,
            variables: {}
          }
        ).then(response => {
            // console.log(response);
            dispatch({
                type: UPDATE_SUBURBS,
                payload: response.data?.data?.suburbsByPostcode || [],
                postcode: postcode
            });
            if (typeof cb === "function") {
                cb(response.data?.data?.suburbsByPostcode);
            }
        }).catch(error => {
            dispatch({type: SET_IS_FETCHING, payload: {isLoadingSuburbs: false}});
            if (typeof errorCb === "function") {
                errorCb(error);
            }
        });
    }
}

export function fetchCurrentDealer(id, cb) {
    return (dispatch, getState) => {
        // console.log("fetchCurrentDealer", id);
        let gqlFilter = {};
        if (/^a[0-9]+$/.test(id.toLowerCase())) {
            gqlFilter = {dealerCode: {eq: id}};
        } else if (/^[0-9]+$/.test(id)) {
            // this is here for backwards compatibility
            gqlFilter = {dealerId: {eq: parseInt(id)}};
        } else {
            // invalid id
            return Promise.resolve();
        }
        gqlFilter.status = {eq: true};
        dispatch({type: SET_IS_FETCHING, payload: {isLoadingCurrent: true}});
        return API.post(
            `${process.env.RAZZLE_GQLAPI}`,
            {
              query: /* GraphQL */`query ($filter: DealerDtoFilterInput) {
                dealerList(where: $filter) {
                  items {
                    dealerCode
                    dealerId
                    status
                    name
                    abn
                    licenceNo
                    sfdcDealerID
                    stripeAccountID
                    dealerGroup
                    region
                    isAudiSportDealer
                    email
                    phone
                    website
                    imageUrl
                    dataCollectionPolicy
                    dealerBusinessManagerEmailAddress
                    dealerPrincipalEmailAddress
                    dealerSalesManagerEmail
                  }
                }
              }`,
              variables: {
                filter: gqlFilter
              }
            }
        ).then(
            (response) => {
                // console.log("fetchCurrentDealer", response);
                let dealer = response.data.data?.dealerList?.items[0];
                if (dealer?.status) {
                    dispatch({
                        type: UPDATE_CURRENT,
                        payload: dealer,
                    });
                    if (typeof cb === 'function') {
                        cb(dealer.dealerCode);
                    }
                }
                return Promise.resolve();
            }
        ).catch(
            (error) => {
                console.log(error);
                dispatch({type: SET_IS_FETCHING, payload: {isLoadingCurrent: false}});
                return Promise.resolve();
            }
        );

    };
}

export function fetchCurrentDealerByReferer(ref, cb) {
    return (dispatch, getState) => {
        dispatch({type: SET_IS_FETCHING, payload: {isLoadingCurrent: true}});
        
        const {hostname} = new URL(ref);
        const refDomain = hostname.replace("www.", "");

        return API.post(
            `${process.env.RAZZLE_GQLAPI}`,
            {
              query: /* GraphQL */`query ($filter: DealerDtoFilterInput) {
                dealerList(where: $filter) {
                  items {
                    dealerCode
                    dealerId
                    status
                    name
                    abn
                    licenceNo
                    sfdcDealerID
                    stripeAccountID
                    dealerGroup
                    region
                    isAudiSportDealer
                    email
                    phone
                    website
                    imageUrl
                    dataCollectionPolicy
                    dealerBusinessManagerEmailAddress
                    dealerPrincipalEmailAddress
                    dealerSalesManagerEmail
                  }
                }
              }`,
              variables: {
                filter: {website: {contains: refDomain}, status: {eq: true}}
              }
            }
        ).then(
            (response) => {
                let dealer = response.data.data?.dealerList?.items[0];
                if (dealer?.status) {
                    dispatch({
                        type: UPDATE_CURRENT,
                        payload: dealer,
                    });
                    if (typeof cb === 'function') {
                        cb(dealer.dealerCode);
                    }
                }
                return Promise.resolve();
            }
        ).catch(
            (err) => {
                dispatch({type: SET_IS_FETCHING, payload: {isLoadingCurrent: false}});
                return Promise.resolve();
            }
        );

    }
}

export function updateSelectedDealer(dealer) {
    return {
        type: UPDATE_SELECTED,
        payload: dealer
    };
}

const defaultState = {
    all: [],
    isLoadingAll: false,
    suburbsByPostcode: {},
    isLoadingSuburbs: false,
    dealersBySuburb: {},
    isLoadingDealersBySuburb: false,
    current: null, // if set, form is locked to this dealer
    selected: null,

    byPostcode: {},
    isLoadingPostcode: false,
    isLoadingCurrent: false
}

export function dealersReducer(state = defaultState, action) {
    switch (action.type) {
        case UPDATE_ALL:
            return Object.assign({}, state, {
                all: action.payload,
                isLoadingAll: false
            });
        case UPDATE_SUBURBS:
            return Object.assign({}, state, {
                suburbsByPostcode: Object.assign({}, state.suburbsByPostcode, {
                    [action.postcode]: action.payload
                }),
                isLoadingSuburbs: false
            });
        case UPDATE_DEALERS_BY_SUBURB:
            return Object.assign({}, state, {
                dealersBySuburb: Object.assign({}, state.dealersBySuburb, {
                    [action.suburbId]: action.payload
                }),
                isLoadingDealersBySuburb: false
            });
        case UPDATE_CURRENT:
            return Object.assign({}, state, {
                current: action.payload,
                isLoadingCurrent: false
            });
        case UPDATE_SELECTED:
            return Object.assign({}, state, {
                selected: action.payload
            });
        case SET_IS_FETCHING:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}
